var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/3 User"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3 User"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M22.3599 13.6207C24.1036 13.3757 25.4461 11.8807 25.4499 10.0694C25.4499 8.28441 24.1486 6.80441 22.4424 6.52441",
    stroke: "#2D3850",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M24.6606 17.8127C26.3494 18.0652 27.5281 18.6565 27.5281 19.8752C27.5281 20.714 26.9731 21.259 26.0756 21.6015",
    stroke: "#2D3850",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8584 18.3296C10.8409 18.3296 7.40967 18.9383 7.40967 21.3696C7.40967 23.7996 10.8197 24.4258 14.8584 24.4258C18.8759 24.4258 22.3059 23.8233 22.3059 21.3908C22.3059 18.9583 18.8972 18.3296 14.8584 18.3296Z",
    stroke: "#2D3850",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8585 14.8598C17.4948 14.8598 19.6323 12.7235 19.6323 10.086C19.6323 7.44976 17.4948 5.31226 14.8585 5.31226C12.2223 5.31226 10.0848 7.44976 10.0848 10.086C10.0748 12.7135 12.196 14.851 14.8235 14.8598H14.8585Z",
    stroke: "#2D3850",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 9",
    d: "M7.35611 13.6207C5.61111 13.3757 4.26986 11.8807 4.26611 10.0694C4.26611 8.28441 5.56736 6.80441 7.27361 6.52441",
    stroke: "#2D3850",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 11",
    d: "M5.055 17.8127C3.36625 18.0652 2.1875 18.6565 2.1875 19.8752C2.1875 20.714 2.7425 21.259 3.64 21.6015",
    stroke: "#2D3850",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.b0436555.svg";
export { ForwardRef as ReactComponent };